module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/home/home.component.html
// module id = ./src/app/views/home/home.component.html
// module chunks = main